import React from 'react'

interface IconProps {
  color?: string
  size?: number
  className?: string
  style?: React.CSSProperties
}

export const Edit: React.FC<IconProps> = ({
  color = '#fff',
  size = 18,
  className,
  style,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 31 32"
    fill="none"
    className={className}
    style={style}
    {...rest}
  >
    <g>
      <path
        d="M20.2118 13.0754L18.4246 11.2882L6.65278 23.0601V24.8472H8.43992L20.2118 13.0754ZM21.9989 11.2882L23.7861 9.50109L21.9989 7.71395L20.2118 9.50109L21.9989 11.2882ZM9.48642 27.375H4.125V22.0123L21.1053 5.03198C21.3424 4.79503 21.6638 4.66193 21.9989 4.66193C22.3341 4.66193 22.6555 4.79503 22.8925 5.03198L26.468 8.60752C26.705 8.84453 26.8381 9.16595 26.8381 9.50109C26.8381 9.83623 26.705 10.1576 26.468 10.3947L9.48768 27.375H9.48642Z"
        fill={color}
      />
    </g>
  </svg>
)
